import React from "react";
import Alert from '@mui/material/Alert';
import {FormattedMessage} from "react-intl";

// From a few thousand products the chunked processing takes several minutes,
// during which the per-organization lock rejects any action of the same type.
const LARGE_BATCH_THRESHOLD = 1000;

export default function LargeBatchWarning({count}) {
    if (!count || count < LARGE_BATCH_THRESHOLD) {
        return null;
    }

    return (
        <Alert severity="warning" sx={{ marginTop: '15px' }}>
            <FormattedMessage
                id={"merchandising.batch_action.modal.large_batch_warning"}
                values={{nb: count}}
            />
        </Alert>
    );
}
